import _ from 'lodash'
import Backbone from 'backbone'
import template from './specific-dates-filter.hbs'
import HasOperatorsFilter from './has-operators-filter'
import EquationAndDateMultiSelector from 'scoreboard/datasets/filters/equation-and-date-multi-selector'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

const SpecificDatesFilter = HasOperatorsFilter.extend({

	className: 'applies-to-date-filter',

	/**
	 * @constructs A view that handles the applies to date portion of a filter
	 *
	 * @param {Object} options.data An object holding the filter data
	 */
	initialize: function(options = {}) {
		options.allowedOperators = ['today', 'on-any-date']
		options.dataType = DATE
		options.operatorName ='dateTimeOperator'
		options.operatorOptions = {today: true}
		if (_.isNil(options.data.dateTimeOperator)) {
			options.data.dateTimeOperator = 'today'
		}
		HasOperatorsFilter.prototype.initialize.apply(this, arguments)
	},

	_renderAdditionalControls: function () {
		this.$el.append(template())
		if (!this.dateFilter) {
			this.dateFilter = new EquationAndDateMultiSelector({
				el: this.$('select[name=dates]'),
				dates: this.data.appliesToDates,
				required: true
			}).render()
		}

		//the values control is not used in this view, it's replace by the above
		this.$('.values-control').addClass('is-not-displayed')

		return this
	},

	_onChangeOperator: function(e) {
		this.$('.dates-label').toggleClass('is-not-displayed', this._isOperatorToday())
	},

	_renderValuesSelect: function() {
		//this view does not use the values select, instead it uses the EquationAndDateMultiSelector
		return null
	},

	test: function() {
		if (!this._isOperatorToday()) {
			return this.dateFilter.markedField.test()
		}
		return null
	},

	gather: function(e) {
		//clear out the previous date data
		this.data = {
			dateTimeOperator: this._operatorSelect().val()
		}
		if (!this._isOperatorToday()) {
			this.data.appliesToDates = this.dateFilter.val()
		}
		return this.data
	},

	_isOperatorToday: function() {
		return this._operatorSelect().val() == 'today'
	},

	remove: function() {
		HasOperatorsFilter.prototype.remove.apply(this, arguments)
		this.dateFilter.remove()
	}

})

export default SpecificDatesFilter

SpecificDatesFilter.__filename__ = 'reports/common/filter/specific-dates-filter.js'
